/**
 * The "DEV" brand mark, matching the icon set in `packages/app/public`.
 *
 * Drawn as paths rather than text so it renders identically regardless of
 * which fonts the browser has available. Letters sit on a 210px cap height
 * (y 151-361) with a 44px stroke weight, inset 40px from each edge.
 */
export const LogoMark = ({ size = 28 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="DEV"
  >
    <rect width="512" height="512" rx="64" fill="#222224" />
    {/* D — x 40-152 */}
    <path
      fill="#ffffff"
      fillRule="evenodd"
      d="M40 151H96A56 56 0 0 1 152 207V305A56 56 0 0 1 96 361H40ZM84 195H96A12 12 0 0 1 108 207V305A12 12 0 0 1 96 317H84Z"
    />
    {/* E — x 182-294 */}
    <path
      fill="#ffffff"
      d="M182 151H294V195H226V236H278V276H226V317H294V361H182Z"
    />
    {/* V — x 324-472 */}
    <path fill="#ffffff" d="M324 151H370L398 306L426 151H472L424 361H372Z" />
  </svg>
);
